<template>
    <div>
        <div class="animate-pulse mb-4 flex space-y-2 flex-col">
            <div class="h-6 w-full sm:w-1/2 bg-gray-200 rounded dark:bg-dark-700"></div>
            <div class="h-4 w-3/4 sm:w-1/4 bg-gray-200 rounded dark:bg-dark-700"></div>
            <div class="h-2 w-1/2 sm:w-1/4 bg-gray-200 rounded dark:bg-dark-700"></div>
        </div>
        <div class="flex justify-end mb-2">
            <div class="h-4 w-1/2 sm:w-1/4 bg-gray-200 rounded dark:bg-dark-700"></div>
        </div>
        <div class="flex flex-col sm:flex-row gap-y-10 sm:gap-x-10 mb-10">
            <div class="px-6 py-4 shadow-md border border-gray-100
                overflow-hidden rounded-lg w-full sm:w-1/2 animate-pulse
                dark:border-dark-700 dark:shadow-dark-md">
                <div class="flex justify-between">
                    <div class="h-5 w-1/3 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-1/3 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex flex-col justify-center w-full">
                    <div class="flex justify-center">
                        <div class="h-16 w-16 my-5 bg-gray-200 rounded-full
                            dark:bg-dark-700"></div>
                    </div>
                    <div class="mt-2 flex justify-center">
                        <div class="h-5 w-3/4 bg-gray-200 rounded dark:bg-dark-700"></div>
                    </div>
                </div>
                <div class="flex justify-between mt-11">
                    <div class="space-y-2 sw-1/2 w-20">
                        <div class="h-4 w-full bg-gray-200 rounded dark:bg-dark-700"></div>
                        <div class="h-7 w-full bg-gray-200 rounded dark:bg-dark-700"></div>
                    </div>
                    <div class="w-20">
                        <div class="h-14 w-full bg-gray-200 rounded dark:bg-dark-700"></div>
                    </div>
                </div>
            </div>
            <div class="px-6 py-4 shadow-md border border-gray-100
                overflow-hidden rounded-lg w-full sm:w-1/2 animate-pulse
                dark:border-dark-700 dark:shadow-dark-md">
                <div class="flex justify-between mb-1">
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-4">
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-1">
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-4">
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-1">
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-4">
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-1">
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-4">
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between mb-1">
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-3 w-16 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
                <div class="flex justify-between">
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                    <div class="h-5 w-20 bg-gray-200 rounded dark:bg-dark-700"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeSkeleton',
};
</script>
